import React, { useState } from "react"
import { GET_ITEM_LIMIT, RPME_MODULE } from "constants/constants"
import { IPermission, Survey } from "interfaces/dataInterfaces"
import {
  useDeleteSurveyRPMEMutation,
  useDownloadOriginSurveyRPMEMutation,
  useDownloadSurveyFileRPMEMutation,
  useGetSurveyRPMEListQuery,
  useGetSurveyRPMEQuery,
  useListCommodityByBasketRPMEQuery,
} from "services/rpme/survey"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query"
import useCommon from "hooks/useCommon"
import SurveyPage from "./SurveyPage"

export interface ISurveyData {
  admCode: number | null
  addAdmCode?: number | null
  xlsFormId?: number | null
  query: string
  pageNumber: number
  itemList: number
  actionItem: { item: Survey; action: "details" | "delete" } | null
}

const permission: IPermission = {
  moduleId: RPME_MODULE,
  subModule: "surveys",
}

const initialState = {
  admCode: null,
  query: "",
  pageNumber: 1,
  itemList: GET_ITEM_LIMIT,
  actionItem: null,
}

function SurveyRPME() {
  const { showSnackBar } = useCommon()
  const [data, setData] = useState<ISurveyData>(initialState)
  const { admCode, query, pageNumber, itemList, actionItem } = data

  const { data: surveyData } = useGetSurveyRPMEListQuery({
    adm0Code: admCode ?? 0,
    search: query,
    skip: pageNumber === 1 ? 0 : (pageNumber - 1) * itemList,
    top: itemList,
  })
  const { data: surveyById } = useGetSurveyRPMEQuery(actionItem?.item?.surveyId ?? 0, {
    skip: !actionItem || actionItem.action !== "details",
  })
  const { data: commodityBasket } = useListCommodityByBasketRPMEQuery(
    { surveyId: actionItem?.item?.surveyId ?? 0 },
    { skip: !actionItem || actionItem.action !== "details" },
  )
  const [deleteSurvey] = useDeleteSurveyRPMEMutation()
  const [downloadSurveyFile] = useDownloadSurveyFileRPMEMutation()
  const [downloadOriginSurvey] = useDownloadOriginSurveyRPMEMutation()

  const onDelete = (id: number) => {
    deleteSurvey(id)
  }

  const onDownloadSurveyFile = async (dataDownload: {
    dataType: string
    surveyId: number
    format: string
  }): Promise<void> => {
    try {
      await downloadSurveyFile(dataDownload).unwrap()
    } catch (err) {
      const error = err as FetchBaseQueryError
      showSnackBar(
        (error?.data as { message: string })?.message ?? "An error occurred while downloading a required file",
        "error",
      )
    }
  }

  const onDownloadOriginSurvey = (dataDownload: { surveyId?: number; file?: string }) => {
    downloadOriginSurvey(dataDownload)
  }

  return (
    <SurveyPage
      data={data}
      setData={setData}
      permission={permission}
      surveyData={surveyData}
      surveyById={surveyById}
      commodityBasket={commodityBasket}
      deleteSurvey={onDelete}
      downloadSurveyFile={onDownloadSurveyFile}
      downloadOriginSurvey={onDownloadOriginSurvey}
    />
  )
}

export default SurveyRPME
